import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/htx/lab-procedures/got";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	got: {
		id: "form.got",
		defaultMessage: "GOT"
	},
	value: {
		id: "form.got.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "got",
	value: {
		title: messages.got,
		validator,
		fieldset,
		isImportant: true
	}
};
